export const INITIAL_PROFILE_VALUE = {
	name: '',
	status: '',
	permissions: [],
	usersCount: 0,
}
